export const ROLES = [
  {
    value: 'operator',
    label: 'Operator'
  },
  {
    value: 'lineInspector',
    label: 'line Inspector'
  },
  {
    value: 'supervisor',
    label: 'Supervisor'
  }
]
